import React from 'react';
import './NavItemList.scss';
import NavItem from '../NavItem/NavItem';
import { shouldShowMenuItem } from '../utils/menuVisibility';

interface NavItemListProps {
    items: Array<{
        href?: string;
        label: string;
        dropdownItems?: Array<{
            href: string;
            label: string;
            target?: string;
            displayFor?: string[];
        }>;
        className?: string;
        buttonClass?: string;
        displayFor?: string[];
    }>;
    className?: string;
    cust_type?: string;
}

const NavItemList: React.FC<NavItemListProps> = ({ items, className = '', cust_type = 'not-logged-in' }) => {
    // Filter top-level items based on customer type
    const filteredItems = items.filter(item => 
        shouldShowMenuItem(item.displayFor, cust_type)
    );

    return (
        <ul className={`nav-item-list ${className}`}>
            {filteredItems.map((item, index) => (
                <NavItem
                    key={index}
                    href={item.href}
                    label={item.label}
                    dropdownItems={item.dropdownItems}
                    className={item.className}
                    buttonClass={item.buttonClass}
                    displayFor={item.displayFor}
                    cust_type={cust_type}
                />
            ))}
        </ul>
    );
};

export default NavItemList;
